export default __webpack_public_path__ + "static/media/q9_step2.39c2b9b4.png";